import { parse } from 'graphql'

/**
 * Cart and cart line types returned by the IT Management Marketplace cell service.
 * Schema uses camelCase (GraphQL-Ruby default).
 */
export interface MarketplaceCartLine {
  id: string
  productId: string
  productVariantId: string
  productOfferId: string
  quantity: number
  unitPrice: string
}

export interface MarketplaceCart {
  id: string
  companyId: string
  customerId: string
  price: string | null
  cartLines: MarketplaceCartLine[]
}

const MARKETPLACE_CART_FRAGMENT = parse(`
  fragment MarketplaceCartFields on Cart {
    id
    companyId
    customerId
    price
    cartLines {
      id
      productId
      productVariantId
      productOfferId
      quantity
      unitPrice
    }
  }
`)

export const GET_MARKETPLACE_CART = parse(`
  query GetMarketplaceCart($id: String!, $companyId: Int!) {
    cart(id: $id, companyId: $companyId) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

export const CREATE_MARKETPLACE_CART = parse(`
  mutation CreateMarketplaceCart($companyId: Int!, $customerId: String!) {
    createCart(companyId: $companyId, customerId: $customerId) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

export const ADD_MARKETPLACE_CART_LINE = parse(`
  mutation AddMarketplaceCartLine(
    $cartId: String!
    $companyId: Int!
    $productId: String!
    $productVariantId: String!
    $productOfferId: String!
    $quantity: Int!
    $unitPrice: Float!
  ) {
    addCartLine(
      cartId: $cartId
      companyId: $companyId
      productId: $productId
      productVariantId: $productVariantId
      productOfferId: $productOfferId
      quantity: $quantity
      unitPrice: $unitPrice
    ) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

export const UPDATE_MARKETPLACE_CART_LINE = parse(`
  mutation UpdateMarketplaceCartLine(
    $cartLineId: String!
    $companyId: Int!
    $quantity: Int!
  ) {
    updateCartLine(cartLineId: $cartLineId, companyId: $companyId, quantity: $quantity) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

export const REMOVE_MARKETPLACE_CART_LINE = parse(`
  mutation RemoveMarketplaceCartLine($cartLineId: String!, $companyId: Int!) {
    removeCartLine(cartLineId: $cartLineId, companyId: $companyId) {
      id
      companyId
      customerId
      price
      cartLines {
        id
        productId
        productVariantId
        productOfferId
        quantity
        unitPrice
      }
    }
  }
`)

const DELETE_MARKETPLACE_CART = parse(`
  mutation DeleteMarketplaceCart($id: String!, $companyId: Int!) {
    deleteCart(id: $id, companyId: $companyId)
  }
`)
